import { useLocation } from 'react-router-dom';
import React from 'react';

import type { Routes } from '../types';

// ----------------------------------------------------------------------

export default function usePathname() {
  const { pathname } = useLocation();

  return React.useMemo(() => pathname as Routes, [pathname]);
}
